import React from 'react';
import { intentContext } from "../contexts/intentContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The intent provider is just a storage for the intent data which will be shared across modules and the interim portal
 * @param children
 * @param value
 * @constructor
 */
export function IntentProvider({
  children,
  ...value
}) {
  return /*#__PURE__*/_jsx(intentContext.Provider, {
    value: value,
    children: children
  });
}